export const idAndFluid = ({node: {id, childImageSharp}}) => ({id, img: childImageSharp.fluid})
